import { render } from "./NewsListTable.vue?vue&type=template&id=43dcfdd3"
import script from "./NewsListTable.vue?vue&type=script&lang=js"
export * from "./NewsListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__